class mapHelper {

    constructor() {
        require('mapbox-gl');
        require('mapbox-gl/dist/mapbox-gl.css');
        this.mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
    }

    init() {

        var mapElement = document.getElementById('map');

        if (mapElement) {
            this.mapboxgl.accessToken = 'pk.eyJ1Ijoiam1vbGxtYW4iLCJhIjoiY2tlbGhrdXlyMDl3cTJxbzlmdDN1cG54NSJ9.R5ZRQUSLYP7T9wu0iTtxEA';

            var lng = document.getElementById('map').dataset.lng,
                lat = document.getElementById('map').dataset.lat;

            var map = new this.mapboxgl.Map({
                container: 'map', // Specify the container ID
                style: 'mapbox://styles/mapbox/outdoors-v11', // Specify which map style to use
                center: [lng, lat], // Specify the starting position [lng, lat]
                zoom: 12, // Specify the starting zoom
                interactive: false
            });

            var marker = new mapboxgl.Marker({
                'color': '#EE2023'
            });

            marker.setLngLat({lng, lat}).addTo(map);
        }
    }
}

window.app.add('map', new mapHelper());